import { render, staticRenderFns } from "./CalendarDetailView.vue?vue&type=template&id=18f6e0d8&"
import script from "./CalendarDetailView.vue?vue&type=script&lang=js&"
export * from "./CalendarDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports